export function getRandomRgb(): string {
  return '#' + window.crypto.getRandomValues(new Uint8Array(3)).reduce((str, byte) => str + byte.toString(16).padStart(2, '0'), '');
}

export function getContrastingColor(color: string): '#000000' | '#FFFFFF' {
  const hex = color.slice(1);
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  // http://stackoverflow.com/a/3943023/112731
  return (r * 0.299 + g * 0.587 + b * 0.114) / 255 > 0.5 ? '#000000' : '#FFFFFF';
}
